/* Step 7a (owner card "AZEX Step 7 Card V2", 29-Oct-2026) — the Method cell of a sample row on the Sampling page: the method
   as it shows (the old specific-vouching name shows the corrected reference ISA 500.A55–A56 — OQ-3), the selection's line
   (approach A "Risk-based selection – not sampling; results are not projected", S14 "100 % examination – not a sample", S16
   "Not a sample — no projection"), and the evaluation summary (best estimate net, "evaluate again" when an item changed). */
import React from "react";
import { methodText, kindLine, amt } from "@/pages/Sampling/evaluationFormat";

export default function SampleMethodCell({ s, t }) {
  const line = kindLine(s, t);
  const sum = s.evaluation_summary;
  const concl = s.conclusion;
  return (
    <div data-testid={`sample-method-${s.id}`}>
      <div>{methodText(s.method, t)}</div>
      {line && (
        <span className="mt-0.5 inline-block rounded border border-sky-300 bg-sky-50 px-1 text-[10px] text-sky-900 dark:bg-sky-950/30 dark:text-sky-200"
              data-testid={`samp-not-a-sample-${s.id}`}>{line}</span>
      )}
      {sum && sum.best_estimate && (
        <div className="mt-0.5 text-[10px]" data-testid={`sample-eval-summary-${s.id}`}>
          {t("s7a.panel.bestEstimate")}: <span className="tabular-nums">{amt(sum.best_estimate.net)}</span>
          {sum.tolerable != null && <> · {t("s7a.panel.tolerable")} <span className="tabular-nums">{amt(sum.tolerable)}</span></>}
          {sum.stale && <span className="ms-1 rounded bg-amber-100 px-1 text-amber-900" data-testid={`sample-eval-stale-${s.id}`}>{t("s7a.panel.staleShort")}</span>}
          {concl && concl.status !== "current" && <span className="ms-1 rounded bg-amber-100 px-1 text-amber-900">{t("s7a.conclusionSuperseded")}</span>}
        </div>
      )}
    </div>
  );
}
